/* Shto cart: add to the cart the same way the theme's own product form does, so the header count updates and the
   theme's cart drawer (or its popdown, per the theme setting "show cart bar") opens exactly as on the live site.
   window.ShtoCart.add([{ id: variantId, quantity: 1 }]) -> Promise of Shopify's /cart/add.js answer.
   It throws with Shopify's message (e.g. "sold out") so the caller can show it. */
(function () {
  if (window.ShtoCart) return;
  var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function json(r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag'); return d; }); }
  window.ShtoCart = {
    add: function (items) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(json).then(function (added) {
        // Same order as the theme (sections/product form in theme.dev.js): header total first, then the drawer.
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        }).catch(function () {}); // only the header count refresh: the item is already in the cart
        var first = (added.items && added.items[0]) || added;
        // The live product template tells Klaviyo "Added to Cart" when its add button is clicked (a custom liquid section
        // using the page's Klaviyo `item`). Same event here, for the page's own product.
        try {
          if (window._learnq && window.item && String(first.product_id) === String(window.item.ProductID)) window._learnq.push(['track', 'Added to Cart', window.item]);
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
          detail: { variant: { id: first.variant_id || first.id }, enabled: !!(window.theme && theme.settings && theme.settings.show_cart_bar) },
          bubbles: true
        }));
        return added;
      });
    }
  };
})();
